import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import About from './pages/About';
import Reader from './pages/Reader';
import './App.css';

export default function App() {
  return (
    <>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Routes>
        <Route path="/" element={<Navigate to="/read/1/1" replace />} />
        <Route path="/read/:chapter/:sloka" element={<Reader />} />
        <Route path="/about" element={<About />} />
        <Route path="*" element={<Navigate to="/read/1/1" replace />} />
      </Routes>
    </>
  );
}
